import PerformanceMeasurement from 'powtoon-commons/performance/performanceMeasurement'
import biTracker from '../bitracker'

const performanceTracker = new PerformanceMeasurement(biTracker)
export default performanceTracker

